import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const DataUploadLogViewerStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "data-upload-log-viewer",
})`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .log__toggle {
    align-self: flex-start;
  }

  .log__empty {
    color: ${rydeColors.grey};
    font-size: 13px;
  }

  .log__list {
    max-height: 240px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 4px;
    border: 1px solid ${rydeColors.lightGreyBorder};
    border-radius: 6px;
    padding: 8px;
    background: ${rydeColors.smoke};
  }

  .log__row {
    display: flex;
    gap: 8px;
    font-size: 12px;
    line-height: 1.4;
    word-break: break-word;
  }

  .log__time {
    flex: 0 0 auto;
    color: ${rydeColors.grey};
    font-variant-numeric: tabular-nums;
  }

  .log__step {
    flex: 0 0 auto;
    color: ${rydeColors.grey};
    text-transform: uppercase;
    font-size: 10px;
    letter-spacing: 0.03em;
    align-self: center;
  }

  .log__message {
    flex: 1 1 auto;
  }

  .log__row--warn .log__message {
    color: ${rydeColors.orange};
  }
`;
